<template>
  <div id="agGeometryConn">
    <b-input-group size="md" prepend="Auth URL">
      <b-input type="text" v-model="connection.authUrl" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
  </div>
</template>


<script>
// components

// server

// modules

export default {
  name: "ag-geometry-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
      authTypes: [
        //{ value: "maxauth", text: "MAXAUTH" },
        //{ value: "form", text: "Form" },
        //{ value: "form", text: "Form" }
      ]
    };
  },

  computed: {

  },

  methods: {

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
      
    },

  }
};
</script>


<style scoped lange="css">

</style>


// WEBPACK FOOTER //
// src/components/connection/GeometryConnection.vue